import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Dreamy%20pastel%20pink%20and%20cream%20abstract%20gradient%20background%20with%20soft%20floating%20cherry%20blossom%20petals%2C%20gentle%20bokeh%20light%20effect%2C%20ethereal%20dreamy%20atmosphere%2C%20feminine%20elegant%20style%2C%20minimal%20artistic%20composition%2C%20warm%20delicate%20tone&width=1800&height=900&seq=hero-main-2026&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/30"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="container-custom text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
            专属少女的
            <br className="md:hidden" />
            梦幻世界
          </h1>
          <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            少女领域，汇聚少女风格的时尚穿搭、美妆教程、生活方式与兴趣内容，
            <br className="hidden md:block" />
            打造属于每一位少女的专属精神乐园，让青春与梦想在这里自由绽放。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/fashion"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              探索少女穿搭
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white font-medium text-sm border border-white/30 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="animate-bounce w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}